"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheStore = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/CacheStore"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * IKEA Component Manager.
 */
var UniqueComponentVerifier = /*#__PURE__*/function () {
  function UniqueComponentVerifier() {
    _classCallCheck(this, UniqueComponentVerifier);
  }

  _createClass(UniqueComponentVerifier, null, [{
    key: "register",

    /**
     * Registers a component class.
     * Outputs a warning to the console if a component already exists.
     *
     * @param {Function} componentClass AbstractComponent class.
     */
    value: function register(componentClass) {
      var existing = this.cacheStore.get(componentClass.componentName);

      if (existing && existing !== componentClass) {
        _Console.default.warn('There is already a version of the "' + componentClass.componentName + '" component registered. This may add to the size of the application and it is therefore recommended to avoid this. Make sure that the module versions are compatible with eachother in your package.json file.');
      } else if (!existing) {
        this.cacheStore.set(componentClass.componentName, componentClass);
      }
    }
    /**
     * Returns the cache store.
     *
     * @returns {CacheStore} Cache store.
     */

  }, {
    key: "cacheStore",
    get: function get() {
      if (!this._cacheStore) {
        this._cacheStore = new _CacheStore.default('UniqueComponentVerifier');
      }

      return this._cacheStore;
    }
  }]);

  return UniqueComponentVerifier;
}();

exports.default = UniqueComponentVerifier;